import {TriggerView} from './triggers.models';

export const validateTriggersData = (data = [], visibleDatapoints = []) => {
  const visibleDatapointsIds = visibleDatapoints.map(datapoint => datapoint.id);
  return data.filter(trigger => visibleDatapointsIds.includes(trigger.dataPoint));
};

export const isSameTriggers = (one, two) => {
  const {condition: conditionOne, dataPoint: dataPointOne} = one || {};
  const {condition: conditionTwo, dataPoint: dataPointTwo} = two || {};
  return (
    dataPointOne.id === dataPointTwo.id &&
    conditionOne.relationalOperator === conditionTwo.relationalOperator &&
    conditionOne.thresholdValue === conditionTwo.thresholdValue &&
    conditionOne.duration === conditionTwo.duration &&
    conditionOne.unitOfTime === conditionTwo.unitOfTime
  );
};

export const apiToTriggerView = (apiTrigger = {}, dataPoint = {}, dataPointDescriptor = {}) => {
  let trigger = new TriggerView(apiTrigger.id);
  trigger.dataPoint = dataPoint;
  //t.ValuesDescriptors
  if (dataPointDescriptor && dataPointDescriptor.values && Object.keys(dataPointDescriptor.values).length > 0) {
    trigger.valuesDescriptors = dataPointDescriptor.values;
  }
  //used to hold the condition after being split into an array
  const condition = apiTrigger.condition.split(' ');
  //read the array in this order  [if, [value], >, 100 ,for, 2 ,seconds]
  const [, , relationalOperator, thresholdValue, , duration, unitOfTime] = condition;
  //t.condition[2]
  trigger.condition.relationalOperator = relationalOperator;
  //t.condition[3]
  if (thresholdValue && thresholdValue.indexOf('.') !== -1) {
    trigger.condition.thresholdValue = parseFloat(thresholdValue);
  } else {
    trigger.condition.thresholdValue = thresholdValue;
  }
  //t.condtion[5]
  trigger.condition.duration = parseInt(duration);
  //t.condition[6]
  trigger.condition.unitOfTime = unitOfTime;
  //t.priority
  trigger.priority = apiTrigger.priority;
  //t.autoClear
  trigger.autoClear = apiTrigger.autoClear;
  //t.notify
  trigger.notifyOnReturn = apiTrigger.notifyOnReturn;

  return trigger;
};
